export const STICKY_NAV_OFFSET_VAR = '--bz-sticky-nav-offset';
/** Top bar (32) + main menu (48) + quote bar (52). Optional ad banners add height at runtime. */
export const DEFAULT_STICKY_NAV_OFFSET_PX = 132;

export function setStickyNavOffset(offsetPx: number): void {
  if (typeof document === 'undefined') return;
  const nextCssValue = `${Math.max(0, Math.round(offsetPx))}px`;
  if (document.documentElement.style.getPropertyValue(STICKY_NAV_OFFSET_VAR) === nextCssValue) return;
  document.documentElement.style.setProperty(STICKY_NAV_OFFSET_VAR, nextCssValue);
}

export function clearStickyNavOffset(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.style.removeProperty(STICKY_NAV_OFFSET_VAR);
}

export function readStickyNavOffset(): number | null {
  if (typeof document === 'undefined') return null;
  const rawCssValue = document.documentElement.style.getPropertyValue(STICKY_NAV_OFFSET_VAR).trim();
  if (!rawCssValue) return null;
  const parsedOffsetPx = Number.parseFloat(rawCssValue);
  return Number.isFinite(parsedOffsetPx) ? Math.max(0, Math.round(parsedOffsetPx)) : null;
}

export function isElementDisplayed(element: HTMLElement): boolean {
  if (!element.isConnected) return false;
  const computedStyle = window.getComputedStyle(element);
  if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
  let ancestor: HTMLElement | null = element.parentElement;
  while (ancestor) {
    if (window.getComputedStyle(ancestor).display === 'none') return false;
    ancestor = ancestor.parentElement;
  }
  return true;
}

/**
 * Visible sticky/fixed edge when pinned near the top; otherwise full height.
 * Prefer bottom so collapsed mobile headers that translate upward still report
 * the visible edge.
 */
export function measureStickyNavOffset(element: HTMLElement): number {
  const boundingRect = element.getBoundingClientRect();
  if (boundingRect.height <= 0) return 0;
  if (boundingRect.top < 1 && boundingRect.bottom > 0) {
    return Math.round(boundingRect.bottom);
  }
  return Math.round(boundingRect.height);
}
